import { Box, Card, Grid, styled } from '@mui/material';
import { Group, Pending, Done, Cancel } from '@mui/icons-material';
import { Small } from '../../../../app/components/Typography';
import React from 'react';

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px !important',
  background: theme.palette.background.paper,
  [theme.breakpoints.down('sm')]: { padding: '16px !important' },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  '& small': { color: theme.palette.text.secondary },
  '& .icon': { opacity: 0.6, fontSize: '44px', color: theme.palette.primary.main },
}));

const Heading = styled('h6')(({ theme }) => ({
  margin: 0,
  marginTop: '4px',
  fontSize: '14px',
  fontWeight: '500',
  color: theme.palette.primary.main,
}));

const StatCards = ({ setActiveTable, employeeData }) => {
  const totalEmployees = employeeData.presentEmployees.length + employeeData.absentEmployees.length;

  const cardList = [
    { name: 'Total Employees', amount: totalEmployees, 
      icon: <Group fontSize="large" />,
      onClick: () => setActiveTable('totalEmployees')
     },
    { name: 'Leave Awaiting Approval', amount: employeeData.pendingApplications.length, icon: <Pending fontSize="large" />, 


      onClick: () => setActiveTable("leaveAwaitingApproval")
    },
    {
      name: 'Present Employee',
      amount: employeeData.presentEmployees.length,
      icon: <Done fontSize="large" />,
      onClick: () => setActiveTable('presentEmployees')
    },
    {
      name: 'Absent Employee',
      amount: employeeData.absentEmployees.length,
      icon: <Cancel fontSize="large" />,
      onClick: () => setActiveTable('absentEmployees')
    },
    
  ];

  return (
    <Grid container spacing={3} sx={{ mb: '24px' }}>
      {cardList.map((item, index) => (
        <Grid item xs={12} md={6} key={index}>
          <StyledCard
            elevation={6}
            style={{ backgroundColor: '#e6e6e6', color: 'black', cursor: item.onClick ? 'pointer' : 'default' }}
            onClick={item.onClick}
          >
            <ContentBox>
              {item.icon}
              <Box ml="12px">
                <Small style={{ color: 'black' }}>{item.name}</Small>
                <Heading>{item.amount}</Heading>
              </Box>
            </ContentBox>
          </StyledCard>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatCards;
